import React from 'react';
import ProjectCard from '../components/proiect-digital-pentru-bine/ProjectCard';

function ProiectDigitalPentruBinePage() {
  return <ProjectCard />;
}

export default ProiectDigitalPentruBinePage;
